const FIND_DONATIONS_FILTER_SETTING_VERSION = 1;
const FIND_DONATIONS_FILTER_SETTING_PREFIX = 'find-donations-filters-v1';

const getFindDonationsFilterSettingKey = (teamId) =>
  teamId
    ? `${FIND_DONATIONS_FILTER_SETTING_PREFIX}:${teamId}`
    : FIND_DONATIONS_FILTER_SETTING_PREFIX;

const findDonationsTimeToMinutes = (value) => {
  if (value == null || value === '') {
    return null;
  }

  if (typeof value === 'string' && value.includes(':')) {
    const match = /^(\d{1,2}):(\d{2})$/.exec(value);
    if (!match) {
      return null;
    }

    const hours = Number(match[1]);
    const minutes = Number(match[2]);
    if (hours > 23 || minutes > 59) {
      return null;
    }

    return hours * 60 + minutes;
  }

  const minutes = Number(value);
  return Number.isInteger(minutes) && minutes >= 0 && minutes < 24 * 60
    ? minutes
    : null;
};

const normalizeFindDonationsTime = (value) => {
  if (value == null) {
    return null;
  }

  const minutes = findDonationsTimeToMinutes(value);
  if (minutes != null) {
    const hours = Math.floor(minutes / 60);
    const minutePart = minutes % 60;
    return `${String(hours).padStart(2, '0')}:${String(minutePart).padStart(
      2,
      '0'
    )}`;
  }

  return null;
};

const normalizeFindDonationsFilters = (value = {}) => ({
  version: FIND_DONATIONS_FILTER_SETTING_VERSION,
  donationFoodTypes: Array.isArray(value.donationFoodTypes)
    ? value.donationFoodTypes
    : [],
  deliveryOptions: Array.isArray(value.deliveryOptions)
    ? value.deliveryOptions
    : [],
  time: value.time || null,
  vehicleType: Array.isArray(value.vehicleType) ? value.vehicleType : [],
  recurringInterval: Array.isArray(value.recurringInterval)
    ? value.recurringInterval
    : [],
  distance:
    value.distance != null && Number.isFinite(Number(value.distance))
      ? Number(value.distance)
      : null,
  rescueHours: Array.isArray(value.rescueHours)
    ? value.rescueHours.map((hour) => ({
        day:
          hour.day != null && Number.isFinite(Number(hour.day))
            ? Number(hour.day)
            : hour.day,
        start_time: normalizeFindDonationsTime(
          hour.start_time ?? hour.open_time
        ),
        end_time: normalizeFindDonationsTime(hour.end_time ?? hour.close_time),
      }))
    : [],
});

module.exports = {
  FIND_DONATIONS_FILTER_SETTING_VERSION,
  FIND_DONATIONS_FILTER_SETTING_PREFIX,
  getFindDonationsFilterSettingKey,
  findDonationsTimeToMinutes,
  normalizeFindDonationsFilters,
};
